import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import { getTrackingAttrs as getTrackingAttrsUtil } from '@Containers/PatentFamilyClustering/utils';
import { viewFullPatentFamily as viewFullPatentFamilyAction } from './actions';
import SinglePatentFromFamily from './SinglePatentFromFamily';

export function SinglePatentFromFamilyContainer({ document, metadata, zoom, viewFullPatentFamily }) {
  const getTrackingAttrs = useMemo(() => getTrackingAttrsUtil({ document, metadata }), [document, metadata]);
  return (
    <SinglePatentFromFamily
      document={document}
      metadata={metadata}
      zoom={zoom}
      isSinglePatent
      getTrackingAttrs={getTrackingAttrs}
      viewFullPatentFamily={viewFullPatentFamily}
    />
  );
}

SinglePatentFromFamilyContainer.propTypes = {
  // Own props
  metadata: MetadataPropTypesShape,
  document: PropTypes.object.isRequired,
  zoom: PropTypes.number,
  // Selectors / Actions
  viewFullPatentFamily: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  viewFullPatentFamily: viewFullPatentFamilyAction,
};

export default connect(null, mapDispatchToProps)(SinglePatentFromFamilyContainer);
